export enum ManageItemType {
  User,
  Organization,
  SpId
}
